<template>
  <div>
    <div
      v-if="item.imageUrl"
      class="card"
    >
      <h3>Item Photo</h3>
      <div class="item-image__wrapper">
        <img
          :src="item.imageUrl"
          class="item-image"
        >
      </div>
    </div>
    <div
      v-if="item.name"
      class="card"
    >
      <h3>Item Name</h3>
      <b-row>
        <b-col md="6">
          English Name
        </b-col>
        <b-col md="6">
          Arabic Name
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          {{ item.name.en }}
        </b-col>
        <b-col md="6">
          {{ item.name.ar }}
        </b-col>
      </b-row>
    </div>
    <div
      v-if="item.description"
      class="card"
    >
      <h3>Item Description</h3>
      <b-row>
        <b-col md="6">
          English Description
        </b-col>
        <b-col md="6">
          Arabic Description
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          {{ item.description.en || "Empty" }}
        </b-col>
        <b-col md="6">
          {{ item.description.ar || "Empty" }}
        </b-col>
      </b-row>
    </div>
    <div
      v-if="item.allergyNote"
      class="card"
    >
      <h3>Item Allergy Note</h3>
      <b-row>
        <b-col md="6">
          English Allergy Note
        </b-col>
        <b-col md="6">
          Arabic Allergy Note
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          {{ item.allergyNote.en || "Empty" }}
        </b-col>
        <b-col md="6">
          {{ item.allergyNote.ar || "Empty" }}
        </b-col>
      </b-row>
    </div>
    <div
      v-if="item.price"
      class="card"
    >
      <h3>Item Price</h3>
      <h6 class="ml-2">
        {{ item.price }}
      </h6>
    </div>
    <div
      v-if="item.selectionGroups"
      class="card"
    >
      <h3>Item Selection Groups</h3>
      <b-row>
        <h6
          v-if="!item.selectionGroups.length"
          class="ml-2"
        >
          No Selection groups for this item
        </h6>
        <b-col
          v-for="(selectionGroup, ix) in item.selectionGroups"
          :key="selectionGroup.name.en + ix"
          md="12"
        >
          <h5>{{ selectionGroup.name.en }} / {{ selectionGroup.name.ar }}</h5>
          <!-- <h6 v-if="!selectionGroup.selections.length">
            No Selections for this group
          </h6>
          <div
            v-for="(selection, index) in selectionGroup.selections"
            :key="selection.name.en + index"
            class="ml-2 d-flex justify-content-between align-items-center"
          >
            <h6>{{ selection.name.en }} / {{ selection.name.ar }}</h6>
            <span>JOD {{ selection.price }}</span>
          </div> -->
          <hr>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: { BRow, BCol },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card {
  padding: 12px;
  border: 1px solid #4b6c95;
}
.item-image__wrapper {
  width: 100px;
  height: 100px;
  border-radius: 12px;
  overflow: hidden;
  background: gray;
}
.item-image {
  min-height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>
